function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.533,13.338V5.542h-2.425V1.667H11.47v3.875H9.045v7.797H6.164v45.775h14.249V13.338H17.533z M9.373,50.021H7.554 v-3.791h1.819V50.021z M9.373,43.752H7.554v-3.79h1.819V43.752z M9.373,37.488H7.554v-3.791h1.819V37.488z M9.373,31.224H7.554 v-3.79h1.819V31.224z M9.373,24.959H7.554v-3.79h1.819V24.959z M9.373,18.795H7.554v-3.79h1.819V18.795z M12.48,50.021h-1.819 v-3.791h1.819V50.021z M12.48,43.752h-1.819v-3.79h1.819V43.752z M12.48,37.488h-1.819v-3.791h1.819V37.488z M12.48,31.224h-1.819 v-3.79h1.819V31.224z M12.48,24.959h-1.819v-3.79h1.819V24.959z M12.48,18.795h-1.819v-3.79h1.819V18.795z M12.48,11.217h-1.819 v-3.79h1.819V11.217z M15.586,50.021h-1.819v-3.791h1.819V50.021z M15.586,43.752h-1.819v-3.79h1.819V43.752z M15.586,37.488 h-1.819v-3.791h1.819V37.488z M15.586,31.224h-1.819v-3.79h1.819V31.224z M15.586,24.959h-1.819v-3.79h1.819V24.959z  M15.586,18.795h-1.819v-3.79h1.819V18.795z M15.586,11.217h-1.819v-3.79h1.819V11.217z M18.694,50.021h-1.818v-3.791h1.818V50.021 z M18.694,43.752h-1.818v-3.79h1.818V43.752z M18.694,37.488h-1.818v-3.791h1.818V37.488z M18.694,31.224h-1.818v-3.79h1.818 V31.224z M18.694,24.959h-1.818v-3.79h1.818V24.959z M18.694,18.795h-1.818v-3.79h1.818V18.795z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.249,6.668V0H31.426v12.126h9.701v46.987h2.122h9.701V6.668H43.249z M41.381,10.004h-8.085V7.427h8.085V10.004z  M41.381,4.85h-8.085V2.272h8.085V4.85z M50.931,50.93h-8.085v-2.578h8.085V50.93z M50.931,45.093h-8.085v-2.578h8.085V45.093z  M50.931,39.258h-8.085V36.68h8.085V39.258z M50.931,33.422h-8.085v-2.579h8.085V33.422z M50.931,27.586h-8.085v-2.577h8.085 V27.586z M50.931,21.751h-8.085v-2.577h8.085V21.751z M50.931,15.915h-8.085v-2.577h8.085V15.915z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.141,13.338v45.775h16.977V13.338H23.141z M27.877,54.236h-1.819v-3.79h1.819V54.236z M27.877,47.39h-1.819v-3.788 h1.819V47.39z M27.877,40.546h-1.819v-3.789h1.819V40.546z M27.877,33.699h-1.819v-3.79h1.819V33.699z M27.877,26.853h-1.819v-3.79 h1.819V26.853z M27.877,20.007h-1.819v-3.79h1.819V20.007z M30.984,54.236h-1.819v-3.79h1.819V54.236z M30.984,47.39h-1.819v-3.788 h1.819V47.39z M30.984,40.546h-1.819v-3.789h1.819V40.546z M30.984,33.699h-1.819v-3.79h1.819V33.699z M30.984,26.853h-1.819v-3.79 h1.819V26.853z M30.984,20.007h-1.819v-3.79h1.819V20.007z M34.092,54.236h-1.819v-3.79h1.819V54.236z M34.092,47.39h-1.819v-3.788 h1.819V47.39z M34.092,40.546h-1.819v-3.789h1.819V40.546z M34.092,33.699h-1.819v-3.79h1.819V33.699z M34.092,26.853h-1.819v-3.79 h1.819V26.853z M34.092,20.007h-1.819v-3.79h1.819V20.007z M37.199,54.236H35.38v-3.79h1.819V54.236z M37.199,47.39H35.38v-3.788 h1.819V47.39z M37.199,40.546H35.38v-3.789h1.819V40.546z M37.199,33.699H35.38v-3.79h1.819V33.699z M37.199,26.853H35.38v-3.79 h1.819V26.853z M37.199,20.007H35.38v-3.79h1.819V20.007z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgSkyscrapers = function SvgSkyscrapers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "59.113px",
    height: "59.113px",
    viewBox: "0 0 59.113 59.113",
    style: {
      enableBackground: "new 0 0 59.113 59.113"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSkyscrapers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/skyscrapers.1e202322.svg";
export { ForwardRef as ReactComponent };